module.exports = __webpack_public_path__ + "img/small.214fa4fc.jpg";